import { IconName } from '@shared/components/core/images/IconMap';
import OrganizationModel from '@shared/models/organizations/OrganizationModel';

export function getOrganizationIcon(organization: OrganizationModel): IconName {
    if (organization.isDeveloperAccess) return 'sdk';
    if (organization.isEmployeeAccess) return 'orgCompany';
    if (organization.isStudentAccess) return 'library';
    if (organization.isReseller) return 'globe';
    if (organization.isPlusAccess) return 'plusLight';
    return 'orgCompany';
}
